"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
const webview_1 = require("./utils/webview");
class WebviewTransport {
    constructor() {
        var _a, _b;
        this.handlers = new Map();
        this.targetOrigin = "*";
        this.targetOrigin = (_b = (_a = window === null || window === void 0 ? void 0 : window.parent) === null || _a === void 0 ? void 0 : _a.origin) !== null && _b !== void 0 ? _b : "*";
        this.platform = (0, webview_1.detectPlatform)();
        if (typeof window !== "undefined") {
            window.addEventListener("message", this.handleMessageEvent.bind(this));
            document.addEventListener("message", this.handleMessageEvent.bind(this));
        }
    }
    on(type, callback) {
        this.handlers.set(type, callback);
    }
    off(type) {
        this.handlers.delete(type);
    }
    post(requestType, data) {
        postMessage(this.platform, requestType, this.targetOrigin, data);
    }
    handleMessageEvent(event) {
        var _a;
        if (((_a = event.target) === null || _a === void 0 ? void 0 : _a.origin) !== this.targetOrigin
            && this.platform !== types_1.WebviewPlatforms.reactNative) {
            return;
        }
        try {
            const { message, type } = JSON.parse(event.data);
            if (!type) {
                console.error("Message received without type");
            }
            const callback = this.handlers.get(type);
            if (callback) {
                callback(message);
            }
        }
        catch (e) {
            if (e instanceof SyntaxError) {
                console.error("Error parsing response.");
            }
            console.error("Failed to handle event.");
        }
    }
    disconnect() {
        window.removeEventListener("message", this.handleMessageEvent.bind(this));
        document.removeEventListener("message", this.handleMessageEvent.bind(this));
    }
}
exports.default = WebviewTransport;
;
const postMessage = (platform, type, targetOrigin, message) => {
    switch (platform) {
        case types_1.WebviewPlatforms.ios:
            return postIosMessage(type, targetOrigin, message);
        case types_1.WebviewPlatforms.reactNative:
            return postReactNativeMessage(type, targetOrigin, message);
        case types_1.WebviewPlatforms.web:
            return postWebMessage(type, targetOrigin, message);
        default:
            const unreachable = () => { throw "Unreachable assert failed."; };
            return unreachable();
    }
};
const postReactNativeMessage = (type, targetOrigin, message) => {
    window.ReactNativeWebView.postMessage(JSON.stringify({ type, message }));
};
const postWebMessage = (type, targetOrigin, message) => {
    window.postMessage(JSON.stringify({ type, message }), targetOrigin);
};
const postIosMessage = (type, targetOrigin, message) => {
    const methodWords = type.split("_").map((s, i) => {
        let word = s.toLowerCase();
        if (i < 1) {
            return word;
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
    });
    methodWords.pop(); // remove "Request" word
    const method = methodWords.join("");
    if (type === types_1.WebViewProviderRequestEnums.signTransactionsRequest) {
        window.webkit.messageHandlers[method].postMessage(message, targetOrigin);
    }
    else {
        window.webkit.messageHandlers[method].postMessage(message);
    }
};
